import { render, staticRenderFns } from "./AdminContract.vue?vue&type=template&id=23d91a28"
import script from "./AdminContract.vue?vue&type=script&lang=js"
export * from "./AdminContract.vue?vue&type=script&lang=js"
import style0 from "./AdminContract.vue?vue&type=style&index=0&id=23d91a28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports